import React from 'react'

import {
    CheckboxField, InputField, FormRow, FieldsetRow, BadgeSelectField, RangeField,
} from '@bikemap/components'
import { gettext } from '@bikemap/js/services'

const t = {
    ROUTE_TYPE: gettext('Route type'),
    LENGTH: gettext('Length'),
    ASCENT: gettext('Ascent'),
    CATEGORIES: gettext('Bike type'),
    SURFACES: gettext('Surface'),
    Q: gettext('Route Title'),
    ONLY_LOOP: gettext('Round-trip route'),
}

/**
 * @typedef {Object} RouteFiltersConfig
 * @property {"metric"|"imperial"} unit
 * @property {number} minDistance
 * @property {number} maxDistance
 * @property {number[]} [distanceScale] Non-linear scale for distance range
 * @property {number} minAscent
 * @property {number} maxAscent
 * @property {number[]} [ascentScale] Non-linear scale for ascent range
 * @property {{ value: number, label: string }[]} categoryOptions
 * @property {{ value: number, label: string }[]} surfaceOptions
 */

/**
 * Filters form for the route search.
 * @param {Object} props
 * @param {import("../../reducers/filtersReducer").SearchFiltersState} props.filters
 * @param {(filters: import("../../reducers/filtersReducer").SearchFiltersState) => void} [props.onChange]
 * @param {RouteFiltersConfig} props.config
 */
const RouteFilters = ({ filters, onChange, config }) => {
    const handleChange = (value, name) => {
        if (onChange) {
            onChange({
                ...filters,
                [name]: value,
            })
        }
    }

    return (
        <form className="route-filters">
            <FormRow variant="xl">
                <RangeField name="distance" icon="i-distance" label={t.LENGTH} step={1} min={config.minDistance}
                    max={config.maxDistance} value={filters.distance} onChange={handleChange}
                    scale={config.distanceScale} unit={(config.unit === 'metric') ? 'km' : 'mi'} infinite />
                <RangeField name="ascent" icon="i-ascent" label={t.ASCENT} step={1} min={config.minAscent}
                    max={config.maxAscent} value={filters.ascent} onChange={handleChange}
                    scale={config.ascentScale} unit={(config.unit === 'metric') ? 'm' : 'ft'} infinite />
            </FormRow>
            <FormRow variant="xl">
                <BadgeSelectField name="categories" label={t.CATEGORIES} options={config.categoryOptions}
                    value={filters.categories} onChange={handleChange} />
                <BadgeSelectField name="surfaces" label={t.SURFACES} options={config.surfaceOptions}
                    value={filters.surfaces} onChange={handleChange} />
            </FormRow>
            <FormRow variant="xl">
                <InputField name="q" label={t.Q} value={filters.q} onChange={handleChange} icon="i-search" secondary />
                <FieldsetRow legend={t.ROUTE_TYPE}>
                    <CheckboxField name="onlyLoop" value={filters.onlyLoop} onChange={handleChange}>
                        {t.ONLY_LOOP} <i className="i-roundtrip i-sm text-secondary" />
                    </CheckboxField>
                </FieldsetRow>
            </FormRow>
        </form>
    )
}

export default RouteFilters
